/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://mckp4qn7ozhglekzb4wz7ncwua.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-s56sz55jjngyhfl5yoxfx22yo4",
    "aws_cognito_identity_pool_id": "us-east-1:c01a8852-a11c-4597-98b6-7c3f477323d7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_OUbllBwZS",
    "aws_user_pools_web_client_id": "7rtj8040ue4kocl1krcm4h8rsa",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "producerlight5a8ede6264aa428080a26eeeaa4913396bf75-mainline",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
